// Central content + brand constants for The Thinkstitute
export const LOGO = {
  full: "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/2gnfszp2_Thinkstitute_logo_2.webp",
  text: "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/f17p4i8r_Thinkstitute_text_logo_2.webp",
};

export const HERO_IMAGE = "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/kt85udd8_67dffdef-9939-4a8c-ac5a-455fd2023247.jpg";

export const CONTACT = {
  phone: "+919227008998",
  phoneDisplay: "+91 92270 08998",
  whatsapp: "919227008998",
  email: "connect@thethinkstitute.in",
  instagram: "https://instagram.com/the.thinkstitute.official",
  instagramHandle: "@the.thinkstitute.official",
  address: "305, J9 High Street Complex, Beside Shiv Shakti Sweets, Vesu Canal Road, Surat, Gujarat 395007",
  mapEmbed: "https://www.google.com/maps?q=J9%20High%20Street%20Vesu%20Canal%20Road%20Surat%20Gujarat%20395007&output=embed",
};

// Home trust strip (text-based)
export const TRUST = [
  { big: "1,000+", small: "Students mentored so far" },
  { big: "10+", small: "Expert subject-specialist faculty" },
  { big: "3 Curricula", small: "CBSE · Commerce · IB MYP — one team" },
];

export const PROGRAMS = [
  {
    id: "cbse",
    icon: "BookOpen",
    tag: "Grades 7–10",
    title: "CBSE",
    color: "#00A896",
    hook: "Rock-solid fundamentals across the core four subjects.",
    subjects: ["Math", "Science", "English", "Social Studies"],
    who: "CBSE students in Grades 7–10 building strong, exam-ready foundations.",
    different:
      "A subject specialist for every subject — not one generalist stretched thin. We teach the reasoning behind concepts, then drill application until it's second nature.",
    weekly: [
      "2-hour classes every day, 6 days a week",
      "Doubt-clearing classes conducted after every chapter",
      "Regular topic tests with individual feedback",
    ],
    outcomes: ["Concept clarity", "Exam technique", "Consistent scores"],
  },
  {
    id: "commerce",
    icon: "TrendingUp",
    tag: "Grades 11–12",
    title: "Commerce & Humanities",
    color: "#3D348B",
    hook: "Board excellence for Commerce and Humanities streams.",
    subjects: ["Accounts", "BST", "Economics", "Pol. Science", "English"],
    who: "Grade 11 & 12 Commerce and Humanities students targeting top board percentages.",
    different:
      "Numerical mastery in Accounts, case-driven Business Studies, application-based Economics and structured Humanities answer-writing — taught by educators who make each stream tangible, not abstract.",
    weekly: [
      "2-hour classes every day, 6 days a week",
      "Doubt-clearing classes conducted after every chapter",
      "Monthly full-syllabus mock boards with analytics",
    ],
    outcomes: ["Board readiness", "Answer-writing skill", "Career direction"],
  },
  {
    id: "ibmyp",
    icon: "Globe",
    tag: "Grades 7–10",
    title: "IB MYP",
    color: "#FF7A29",
    hook: "Inquiry-led learning aligned to the MYP framework.",
    subjects: ["Math", "Science", "Language & Literature"],
    who: "IB Middle Years Programme students in Grades 7–10.",
    different:
      "We teach to the MYP criteria — inquiry, communication, critical thinking — with educators who understand internal assessment and help students genuinely think, not just perform.",
    weekly: [
      "2-hour classes every day, 6 days a week",
      "Doubt-clearing classes conducted after every chapter",
      "Criterion-based tasks with detailed rubric feedback",
    ],
    outcomes: ["Criterion mastery", "Independent thinking", "IA confidence"],
  },
];

export const WHY_US = [
  {
    n: "01",
    title: "Small-Batch Attention",
    text: "Capped cohorts so every student is seen, heard and mentored personally.",
  },
  {
    n: "02",
    title: "A Specialist per Subject",
    text: "Educators who teach one subject deeply — never a generalist juggling everything.",
  },
  {
    n: "03",
    title: "Real, Repeatable Results",
    text: "Structured tests and analytics that turn effort into measurable improvement.",
  },
  {
    n: "04",
    title: "Parents in the Loop",
    text: "Transparent monthly updates and open communication with every family.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "My daughter went from dreading math to teaching her friends. The subject specialists here actually made it click.",
    name: "Priya Mehta",
    role: "Parent · CBSE Grade 9",
  },
  {
    quote:
      "The Accounts numericals used to terrify me. The monthly mocks meant the real board felt easy.",
    name: "Rinkesh Patel",
    role: "Commerce · Grade 12",
  },
  {
    quote:
      "They understood the MYP criteria better than anyone. My son's internal assessments improved dramatically.",
    name: "Rakesh Patel",
    role: "Parent · IB MYP Grade 10",
  },
];

export const FOUNDER = {
  name: "Chirag Kankaria",
  role: "Founder & Director",
  color: "#3D348B",
  photo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/6xt3hedc_Chirag%20Sir.webp",
  story: [
    "Before starting The Thinkstitute, Chirag noticed something that most coaching institutes seemed to accept as normal: one teacher covering four or five subjects, students memorizing for exams instead of actually understanding concepts, and parents left guessing about how their child was really doing.",
    "He didn't think that had to be the standard. So he built something different — a place where every subject is taught by someone who specializes in exactly that subject, where the goal is real understanding over rushed syllabus completion, and where parents are kept genuinely informed, not just reassured.",
    "That idea became The Thinkstitute. Eight years later, it's grown into a team of dedicated subject specialists serving Grades 7 through 12 across CBSE, CBSE Commerce, and IB MYP — but the founding belief hasn't changed: education should go beyond the textbook.",
  ],
};

export const TEAM = [
  { name: "Chirag Kankaria", role: "Founder & Director · Math & Science", wing: "Leadership", bio: "Leads the institute and teaches Math & Science across both CBSE and IB levels.", color: "#3D348B", photo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/6xt3hedc_Chirag%20Sir.webp" },
  { name: "Khushboo Ma'am", role: "Chief Operations Officer", wing: "Leadership", bio: "Keeps everything running smoothly for students, parents and educators.", color: "#FF7A29", photo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/jz4zhg4e_Khushboo%20Mam.webp" },
  { name: "Samarth Modi", role: "Mathematics Educator", wing: "CBSE", bio: "Makes mathematics logical, visual and genuinely enjoyable.", color: "#00A896", photo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/cjjvy56p_Samarth%20Sir.webp" },
  { name: "Swati Ma'am", role: "Science Educator", wing: "CBSE", bio: "Hands-on science that makes every concept click.", color: "#3D348B", photo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/w3stfetf_Swati%20Mam.webp" },
  { name: "Nilesh Karnani", role: "Social Science Educator", wing: "CBSE", bio: "Turns dates, maps and events into stories students remember.", color: "#FF7A29", photo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/9wrfdv60_Nilesh%20Sir.webp" },
  { name: "Sunil Pahuja", role: "English Educator", wing: "CBSE", bio: "Builds confident readers, writers and communicators.", color: "#14213D", photo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/1o1x02xj_Sunil%20Sir.webp" },
  { name: "Sachayita (Millie) Ma'am", role: "Language & Literature · IB Growth Co-ordinator", wing: "IB", bio: "Language & Literature expert guiding our IB programme and growth.", color: "#00A896", photo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/zq55m8vo_Millie%20Mam.webp" },
];

export const TEAM_PHOTO = "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/5aet1whj_Team%20Photo.webp";

export const FAQS = [
  {
    q: "What are the batch timings?",
    a: "For CBSE, batch timings are between 3:30 PM and 6:30 PM. For IB MYP, timings are between 5:00 PM and 8:30 PM. We fit around your child's school schedule.",
  },
  {
    q: "How is the fee structure decided?",
    a: "Fees depend on the curriculum, grade and number of subjects, and can be paid quarterly or annually. Book a free consultation and we'll share a transparent, no-obligation breakdown.",
  },
  {
    q: "How does the admissions process work?",
    a: "Step 1: Book a free consultation. Step 2: A short diagnostic to understand your child's current level. Step 3: We recommend the right program and batch. Step 4: Enrol and begin.",
  },
  {
    q: "How large are the batches?",
    a: "We keep batches small so every learner gets genuine personal attention and mentoring — never lost in a crowd.",
  },
  {
    q: "Do you share progress with parents?",
    a: "Yes. Parents receive monthly performance updates and can also track their child's weekly test performance anytime through our app.",
  },
];

export const GRADES = ["Grade 7", "Grade 8", "Grade 9", "Grade 10", "Grade 11", "Grade 12"];
export const PROGRAM_OPTIONS = PROGRAMS.map((p) => p.title);

// Gallery — placeholder stock photos; replace with real institute photos.
export const ALBUMS = ["All", "Classes", "Events", "Results"];

export const GALLERY = [
  // Real event photos
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/eyhlto4q_TTPL%20Auction.webp", caption: "TTPL Auction — the student cricket league draft night", album: "Events", tall: true },
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/p3915ouz_ThinkFest.webp", caption: "ThinkFest — our annual campus celebration", album: "Events" },
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/n06w7eye_Cosmology.webp", caption: "Cosmology · Sunset observation session", album: "Events" },
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/56o2juoq_Cosmology%20Workshop.webp", caption: "Cosmology Workshop — quiz champions felicitated", album: "Events", tall: true },
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_thinkclass/artifacts/rbdsczs2_Tyre%20Patching%20Workshop.webp", caption: "Tyre Patching Workshop — hands-on learning off-campus", album: "Events" },

  // Classes (placeholder — replace with real photos when ready)
  { src: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=1000&q=80", caption: "Live problem-solving in a CBSE batch", album: "Classes", tall: true },
  { src: "https://images.unsplash.com/photo-1571260899304-425eee4c7efc?w=1000&q=80", caption: "Small-batch mentoring in action", album: "Classes" },
  { src: "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=1000&q=80", caption: "Concept lab — learning by doing", album: "Classes" },
  { src: "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=1000&q=80", caption: "Our bright, focused study spaces", album: "Classes", tall: true },
  { src: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=1000&q=80", caption: "Doubt-clearing war room", album: "Classes" },

  // Results (placeholder — replace with real photos when ready)
  { src: "https://images.unsplash.com/photo-1509228468518-180dd4864904?w=1000&q=80", caption: "Board-exam achievers celebrating results", album: "Results", tall: true },
  { src: "https://images.unsplash.com/photo-1531482615713-2afd69097998?w=1000&q=80", caption: "Toppers felicitation ceremony", album: "Results" },
  { src: "https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=1000&q=80", caption: "Rank holders with their mentors", album: "Results" },
];

// Video testimonials — placeholder sample videos; replace with real clips.
export const VIDEO_TESTIMONIALS = [
  {
    poster: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&q=80",
    video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
    name: "Priya Mehta",
    role: "Parent · CBSE Grade 9",
    line: "\"The transformation in my daughter has been incredible.\"",
  },
  {
    poster: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=800&q=80",
    video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
    name: "Aarav Shah",
    role: "Commerce & Humanities · Grade 12",
    line: "\"The mock boards made the real exam feel easy.\"",
  },
  {
    poster: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=800&q=80",
    video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
    name: "Ritika Sharma",
    role: "Parent · IB MYP Grade 10",
    line: "\"They truly understand the IB MYP framework.\"",
  },
];

// Photo-based testimonials — placeholder portraits; replace with real ones.
export const PHOTO_TESTIMONIALS = [
  {
    photo: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&q=80",
    quote: "The subject specialists made maths click for my daughter. Her confidence has completely transformed this year.",
    name: "Priya Mehta",
    role: "Parent · CBSE Grade 9",
  },
  {
    photo: "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=400&q=80",
    quote: "The monthly mock boards were tougher than the real exam — walking in, I felt completely ready.",
    name: "Aarav Shah",
    role: "Commerce & Humanities · Grade 12",
  },
  {
    photo: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80",
    quote: "They understood the IB MYP criteria better than anyone. My son's internal assessments improved dramatically.",
    name: "Ritika Sharma",
    role: "Parent · IB MYP Grade 10",
  },
  {
    photo: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=400&q=80",
    quote: "Teaching here means really knowing every student. Small batches let us mentor, not just lecture.",
    name: "Samarth Modi",
    role: "Mathematics Educator",
  },
  {
    photo: "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?w=400&q=80",
    quote: "From struggling with Accounts to scoring 95 — the numerical practice sessions changed everything for me.",
    name: "Ishaan Patel",
    role: "Alumnus · Commerce 2023",
  },
  {
    photo: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&q=80",
    quote: "As a parent, the transparent monthly updates gave me total peace of mind about my child's progress.",
    name: "Anita Desai",
    role: "Parent · CBSE Grade 8",
  },
];

